<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zyIn8S/tc-custom/9781453214954.jpg?1705633989430" alt="This image is the cover for the book Asta's Book"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Asta's Book
      </h1>
      <p class="bookDescription body article font2">
        <b>An “obsessively readable” mystery from the <i>New York Times–</i>bestselling author of <i>Dark Corners</i> about a century-old diary that holds clues to a murder (<i>The Sunday Telegraph</i>).</b><br/><br/>  Asta Westerby is lonely. In 1905, shortly after coming to East London from Denmark with her husband and their two little boys, she feels like a stranger in a strange land. And it doesn’t help that her husband is constantly away on business. Fortunately, she finds solace in her diary—and she continues to do so until 1967.<br/>  <br/> Decades later, her granddaughter, Ann, finds the journal, and it becomes a literary sensation, offering an intimate view of Edwardian life. But it also appears to hold the key to an unsolved murder and the disappearance of a child.<br/>  <br/> A modern masterpiece by the Edgar Award–winning author of the Inspector Wexford Mysteries, and an excellent choice for readers of P. D. James, Ian Rankin, or Scott Turow,<i> Asta’s Book</i> is at once a crime story, a historical novel, and a psychological portrait told through the diary itself and through Ann, who is bent on unlocking the journal’s excised mystery.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruth Rendell
      </h2>
      
      <p class="authorDescription body article"><p>Edgar Award&ndash;winning author Ruth Rendell (b. 1930) has written more than seventy books and sold more than twenty million copies worldwide. A fellow of the Royal Society of Literature (London), she is the recipient of the Grand Master Award from the Mystery Writers of America and a Lifetime Achievement Award from the Crime Writers&rsquo; Association. Rendell&rsquo;s award-winning novels include <i>A Demon in My View</i> (1976), <i>A Dark-Adapted Eye </i>(1987), and <i>King Solomon&rsquo;s Carpet </i>(1991). Her popular crime stories featuring Chief Inspector Reginald Wexford were adapted into a long-running British television series (1987&ndash;2000) starring George Baker.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b68d6e5e